<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M4.42675 9.57318L7.82323 6.17674C7.92086 6.07911 8.07915 6.07911 8.17678 6.17674L11.5732 9.57318C11.7307 9.73068 11.6192 9.99996 11.3964 9.99996H4.60353C4.3808 9.99996 4.26926 9.73067 4.42675 9.57318Z"
    fill="currentColor"
  />
</svg>
